import React from "react";

class ReviewsIcon extends React.Component {
  render() {
    return (
      <i className="anticon anticon-profile">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="1.18em"
          height="1em"
          viewBox="0 0 20 17"
        >
          <path
            id="Forma_1"
            data-name="Forma 1"
            d="M78.27,545.359H73.818v-3.637A1.723,1.723,0,0,0,72.108,540h-10.4A1.723,1.723,0,0,0,60,541.722v6.3a1.723,1.723,0,0,0,1.709,1.722h1.012L64,551.47a0.4,0.4,0,0,0,.361.171,0.5,0.5,0,0,0,.361-0.171l1.275-1.722h0.192v3.637a1.723,1.723,0,0,0,1.709,1.722h6.113l1.275,1.722a0.4,0.4,0,0,0,.361.171A0.5,0.5,0,0,0,76,556.829l1.275-1.722h1.012A1.723,1.723,0,0,0,80,553.385v-6.3A1.722,1.722,0,0,0,78.27,545.359ZM65.754,548.85a0.5,0.5,0,0,0-.361.171l-1.059,1.405-1.059-1.405a0.4,0.4,0,0,0-.361-0.171H61.663a0.815,0.815,0,0,1-.818-0.824v-6.3a0.815,0.815,0,0,1,.818-0.824h10.4a0.815,0.815,0,0,1,.818.824v6.3a0.815,0.815,0,0,1-.818.824H65.754Zm13.358,4.535a0.814,0.814,0,0,1-.818.824H77.042a0.5,0.5,0,0,0-.361.171l-1.059,1.406-1.058-1.406a0.4,0.4,0,0,0-.361-0.171H67.9a0.814,0.814,0,0,1-.818-0.824v-3.637h5.03a1.669,1.669,0,0,0,.914-0.267h3.37a0.436,0.436,0,0,0,0-.871H73.744a1.5,1.5,0,0,0,.1-0.581v-1.747h4.453a0.815,0.815,0,0,1,.818.824v6.279h0ZM76.8,551.542a0.432,0.432,0,0,1-.432.436H69.822a0.436,0.436,0,0,1,0-.871h6.548A0.431,0.431,0,0,1,76.8,551.542Zm-6.668-4.923H63.61a0.436,0.436,0,0,1,0-.871h6.523a0.431,0.431,0,0,1,.432.435A0.417,0.417,0,0,1,70.134,546.619Zm-6.956-2.957a0.432,0.432,0,0,1,.432-0.436h3.922a0.436,0.436,0,0,1,0,.871H63.61A0.431,0.431,0,0,1,63.178,543.662Z"
            transform="translate(-60 -540)"
            fill="currentColor"
          />
        </svg>
      </i>
    );
  }
}

export default ReviewsIcon;
